// Positions and lines as the cards name them: one key per position across
// games, and the moves to it as a scoresheet writes them. Shared by every
// card that groups the reader's moves by position (the Openings screen's
// "Positions you keep getting wrong", a game's "You've played this before").
import type { Fen, San } from '@chess/api-model';

/** A position's key: the FEN's board, side to move, castling and en passant, without the move counters. */
export const positionKey = (fen: Fen) => fen.split(' ').slice(0, 4).join(' ');

/** A move as a scoresheet writes it: `4.d4` for White, `4…d6` for Black (`ply` 1-based). */
export const numberedMove = (ply: number, san: string) => `${Math.ceil(ply / 2)}${ply % 2 ? '.' : '…'}${san}`;

/** The last `plies` of a line, numbered: `1.e4 e5 2.Nf3`, or `…3.Bc4 Bc5` when cut on White's move. */
export function lineTail(line: readonly San[], plies = 8): string {
  const from = Math.max(0, line.length - plies);
  const parts = line.slice(from).map((san, i) => {
    const ply = from + i + 1;
    return ply % 2 || i === 0 ? numberedMove(ply, san) : san;
  });
  // A cut line starting on White's move says so; one starting on Black's already reads `4…`.
  return (from > 0 && from % 2 === 0 ? '…' : '') + parts.join(' ');
}
